import { Paid } from "./paid";
import { Park } from "./park";
import { Payments } from "./payments";
import { Pdf } from "./pdf"
import { PedalBike } from "./pedal_bike";
import { PeopleAlt } from "./people_alt";
import { PersonPin } from "./person_pin";
import { PersonSearch } from "./person_search";
import { Person } from "./person";
import { PestControlRodent } from "./pest_control_rodent";
import { Pets } from "./pets";
import { Phone } from "./phone";
import { PhotoAlbum } from "./photo_album";
import { PictureAsPdf } from "./picture_as_pdf";
import { PlayCircle } from "./playCircle";
import { PrecisionManufacturing } from "./precision_manufacturing";
import { PregnantWoman } from "./pregnant_woman";
import { PriorityHigh } from "./priority_high";
import { Psychology } from "./psychology";
import { Public } from "./public";
import { PushPin } from "./push_pin";

const iconsList = [
  { label: "Paid", code: <Paid /> },
  { label: "Park", code: <Park /> },
  { label: "Payments", code: <Payments /> },
  { label: "Pdf", code: <Pdf /> },
  { label: "PedalBike", code: <PedalBike /> },
  { label: "PeopleAlt", code: <PeopleAlt /> },
  { label: "PersonPin", code: <PersonPin /> },
  { label: "PersonSearch", code: <PersonSearch /> },
  { label: "Person", code: <Person /> },
  { label: "PestControlRodent", code: <PestControlRodent /> },
  { label: "Pets", code: <Pets /> },
  { label: "Phone", code: <Phone /> },
  { label: "PhotoAlbum", code: <PhotoAlbum /> },
  { label: "PictureAsPdf", code: <PictureAsPdf /> },
  { label: "PlayCircle", code: <PlayCircle /> },
  { label: "PrecisionManufacturing", code: <PrecisionManufacturing /> },
  { label: "PregnantWoman", code: <PregnantWoman /> },
  { label: "PriorityHigh", code: <PriorityHigh /> },
  { label: "Psychology", code: <Psychology /> },
  { label: "Public", code: <Public /> },
  { label: "PushPin", code: <PushPin /> },
];

export {
  iconsList,
  Paid,
  Park,
  Payments,
  Pdf,
  PedalBike,
  PeopleAlt,
  PersonPin,
  PersonSearch,
  Person,
  PestControlRodent,
  Pets,
  Phone,
  PhotoAlbum,
  PictureAsPdf,
  PlayCircle,
  PrecisionManufacturing,
  PregnantWoman,
  PriorityHigh,
  Psychology,
  Public,
  PushPin,
};
